import { LinearProgress } from "@mui/material";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import React, { useState } from "react";
import { Fragment } from "react/jsx-runtime";

import { TaskListRow } from "../TaskListRow";

import { TaskTablePropInterface } from "./TaskTable";

import { getCurrentPage } from "@/utils/helpers.utils";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

export const TaskTable: React.FC<TaskTablePropInterface> = ({
  isLoading,
  refetch,
  taskList,
}) => {
  const [offset, setOffset] = useState<number>(0);
  const [limit, setLimit] = useState<number>(50);

  const handleChangePage = (event: unknown, newPage: number) => {
    setOffset(newPage * limit);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLimit(+event.target.value);
  };

  return (
    <Fragment>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <StyledTableCell>Description</StyledTableCell>
              <StyledTableCell align="left">Tag</StyledTableCell>
              <StyledTableCell align="left">Project</StyledTableCell>
              <StyledTableCell align="left">Start Time</StyledTableCell>
              <StyledTableCell align="left">End Time</StyledTableCell>
              <StyledTableCell align="left">Total Time</StyledTableCell>
              <StyledTableCell align="center">Action</StyledTableCell>
            </TableRow>
          </TableHead>
          {isLoading && <LinearProgress color="success" />}
          <TableBody>
            {(taskList?.data?.results || []).map((task) => (
              <TaskListRow
                key={task?.id}
                task={task}
                refetchTableData={refetch}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[25, 50, 100]}
        component="div"
        count={taskList?.data?.count || 0}
        rowsPerPage={limit}
        page={getCurrentPage(offset, limit)}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Fragment>
  )
}